import { Component, OnInit, Output, EventEmitter, ViewChild, AfterViewInit, HostListener } from '@angular/core';
import { ServiceStock } from 'src/app/service-stock.service';
import { MarketWatchService } from 'src/app/market-watch.service';
import { HttpResponse } from '@angular/common/http';
import { MarketWatchHeader } from './MarketWatchHeader.model';
import { gotxModalComponent } from 'src/app/gotxModal/gotxModal.component';
import { WatchListModel } from '../../pages/WatchList/WatchList.model';
import { StockComponent } from '../Stock/Stock.component';
import { Sort } from './sort';
import { GotxMarketDepthComponent } from '../gotx-market-depth/gotx-market-depth.component';
import { NumericFilterPipe } from 'src/app/numeric-filter.pipe';
import { GotxMenuComponent } from '../gotx-menu/gotx-menu.component';
import { Data } from 'src/app/DataService';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-gotx-market-watch',
  templateUrl: './gotx-market-watch.component.html',
  styleUrls: ['./gotx-market-watch.component.scss']
})
export class GotxMarketWatchComponent implements OnInit, AfterViewInit {
  marketData = null;
  sectorList: any[] = [];
  productList: any[] = [];
  selectedWatchList = "";
  selectedSector = "";
  selectedProduct = "";
  hideSector: boolean = true;
  stockData;
  stockDatafields;

  exchange: string = '';
  product: string = '';
  exchSymbol: string = '';
  symbol: string = '';
  board: string = '';
  symbolName = "NA";
  secName = "NA";
  keyValueList: any[] = [];
  keyValueList1: any[] = [];
  newsList: any[] = [];

  selectedStock: any = null;
  defaultIndex: string = '';
  tickerExpand: boolean = false;
  tickerList: any[] = [];
  // tickerMasterMap = new Map();

  MyPortfolioList: any[] = []; // **UserPreference
  productValue: any[] = [];
  productSelected = this.services.dataStore.getproductMasterData();
  defaultListData:any;
  productListArray:any;
  showOptionChain: boolean = false;
  portfolioLength: number = 0;

  touchlineSelected;
  contextMenuRowSelected;

  @ViewChild('cmbStock', { static: false }) cmbStock: StockComponent;
  @ViewChild('marketDepth', { static: false }) marketDepth: GotxMarketDepthComponent;
  @ViewChild('gotxMenuComp', { static: false }) gotxMenuComp: GotxMenuComponent;
  @Output() editColumn = new EventEmitter<String>();

  constructor(private services: ServiceStock, private marketService: MarketWatchService, public marketWatchHeader: MarketWatchHeader, public watchlistModel: WatchListModel, private filter: NumericFilterPipe) { }

  @HostListener('window:keydown.F1', ['$event'])
  handleF1(event: KeyboardEvent) {
    event.preventDefault();
    this.openModal("Order Book");
  }

  @HostListener('window:keydown.F2', ['$event'])
  handleF2(event: KeyboardEvent) {
    event.preventDefault();
    if (this.touchlineSelected != null) {
      this.openOrderEntry("Buy", this.touchlineSelected);
    } else {
      this.openModal("Buy");
    }
  }

  @HostListener('window:keydown.F3', ['$event'])
  handleF3(event: KeyboardEvent) {
    event.preventDefault();
    if (this.touchlineSelected != null) {
      this.openOrderEntry("Sell", this.touchlineSelected);
    } else {
      this.openModal("Sell");
    }
  }
  @HostListener('window:keydown.F4', ['$event'])
  handleF4(event: KeyboardEvent) {
    event.preventDefault();
    this.openModal("Watchlist");
  }

  @HostListener('window:keydown.F6', ['$event'])
  handleF6(event: KeyboardEvent) {
    event.preventDefault();
    if (this.touchlineSelected != null) {
      this.openMarketDepth(this.touchlineSelected);
    } else {
      this.openModal("Market Depth");
    }
  }
  @HostListener('window:keydown.F7', ['$event'])
  handleF7(event: KeyboardEvent) {
    event.preventDefault();
    if (this.touchlineSelected != null) {
      this.openChart(this.touchlineSelected);
    } else {
      this.openModal("Intraday Chart");
    }
  }
  setProductField(value: string): void {
    if(value == "EQUITY"){
        this.productSelected = value;
    }else if(value == "FUTCOM" || value == "OPTCOM"){
        this.productSelected = "COMDERV";
    }else if(value == "FUTSTK" || value == "FUTIDX" || value == "OPTSTK" || value == "OPTIDX"){
        this.productSelected = "FUTOPT";
    }
   
    
  }
    message = '';
    subscription!: Subscription;
  ngOnInit() {
    this.marketService.getMarketWatchStockResp();
    this.marketService.getMarketData();
    this.getTickerInfo();
    this.setProductField(this.productSelected);

    this.loadSectorAndProductList();
   // this.selectedWatchList = this.services.dataStore.getWatchList()[0].id;//commented by pooja
    // **UserPreference
    this.services.dataStore.getWatchList().forEach(element => {
      if (element.isDefault) {
        this.selectedWatchList = element.id;  
      }
    });
   
    

    this.keyValueList = [];
    this.keyValueList.push({ key: "MarketInstrumentDetails.High", value: 'highPrice' || 0, textAlign: "right", format: '1.2-2' });
    this.keyValueList.push({ key: "MarketInstrumentDetails.Volume", value: 'volume' || 0, textAlign: "right", format: '' });
    this.keyValueList.push({ key: "MarketInstrumentDetails.TotBidQty", value: 'totalBuyQty' || 0, textAlign: "right", format: '' });
    this.keyValueList.push({ key: "MarketInstrumentDetails.PrevClose", value: 'prevClose' || 0, textAlign: "right", format: '1.2-2' });

    this.keyValueList1 = [];
    this.keyValueList1.push({ key: "MarketInstrumentDetails.Low", value: 'lowPrice' || 0, textAlign: "right", format: '1.2-2' });
    this.keyValueList1.push({ key: "MarketInstrumentDetails.Turnover", value: 'turnover' || 0, textAlign: "right", format: '' });
    this.keyValueList1.push({ key: "MarketInstrumentDetails.TotAskQty", value: 'totalSellQty' || 0, textAlign: "right", format: '' });
    this.keyValueList1.push({ key: "MarketInstrumentDetails.LastPrice", value: 'lastPrice' || 0, textAlign: "right", format: '1.2-2' });

    if (this.services.dataStore.getData("defaultIndex") != "") {

      this.defaultIndex = this.services.dataStore.getData("defaultIndex").split(',')[0];
    }
    //this.getMyPortfolio("checkData");
    this.subscription = this.services.dataStore.message$.subscribe(msg => {
        this.message = msg;
        //console.log("message received...>",this.message);
        //console.log("product received...>",this.productSelected);
        if(this.productSelected=="EQUITY"){
        this.onWatchListChange("CSE30");
        }else if(this.productSelected=="COMDERV"){
        this.onWatchListChange("COMWATCH");
        }else if (this.productSelected=="FUTOPT"){
        this.onWatchListChange("FOWATCH");
        }
      });
  }

  async ngAfterViewInit() {
    setTimeout(async () => {
      await this.reloadStock();
      this.loadMarketWatch();
    });
   /* this.defaultListData = this.services.UserPreference.userPreference;
   console.log("this.defaultListData",this.defaultListData.DefaultList);
    if(this.defaultListData.DefaultList.length != 0  ){
      console.log("has default list",this.defaultListData.DefaultList[0]);
      this.selectedWatchList = this.defaultListData.DefaultList[0];
      
    }else{
      console.log("does not have default list",this.watchlistModel.watchListOptions);
      
     if(!this.productList.includes("EQUITY") && (this.productList.includes("FUTCOM") || this.productList.includes("OPTCOM")) ){

      console.log("if comwatch");
      this.selectedWatchList = "COMWATCH";
     }else{

      console.log(" else comwatch");
      this.selectedWatchList = "CSE30";
     }
     
    }*/
     this.defaultListData = this.services.UserPreference.userPreference;
     this.productListArray =  this.services.dataStore.getProductSource();
      if(this.defaultListData.DefaultList.length != 0  ){
        this.selectedWatchList = this.defaultListData.DefaultList[0];
        this.marketData = this.services.dataStore.watchListMap.get(this.selectedWatchList);
        
      }else if(!this.productListArray.includes("EQUITY") && (this.productListArray.includes("FUTCOM") || this.productListArray.includes("OPTCOM"))){
        this.selectedWatchList = "COMWATCH";
        //this.marketData = this.services.dataStore.watchListMap.get(this.selectedWatchList);
        this.marketData = this.services.dataStore.watchListMap.get(this.selectedWatchList).slice(0,30);
        //console.log("this.marketData length",this.marketData);
      }else if(this.productListArray.includes("FUTSTK")||this.productListArray.includes("OPTSTK")||this.productListArray.includes("FUTIDX")||this.productListArray.includes("OPTIDX")){
        this.selectedWatchList = "FOWATCH";
        //this.marketData = this.services.dataStore.watchListMap.get(this.selectedWatchList);
        this.marketData = this.services.dataStore.watchListMap.get(this.selectedWatchList).slice(0,30);
      }
      else{
        this.getMyPortfolio("checkData");
      }
  }

  ngOnDestroy() {
    this.marketService.unSubscribeMarket(this.services.dataStore.subbedStocks);
    this.gotxMenuComp.gotxMenu.close();
  }

  onTickerClick() {
    this.tickerExpand = !this.tickerExpand;
    if (this.tickerExpand) {
      this.marketService.tickerSubs();

      document.getElementById("MWTable").style.height = "calc(100vh - 235px)";
      document.getElementById("MWInfoPane").style.height = "calc(100vh - 235px)";

      // Delete Starts
      // let data = {
      //   "StockHeader": {
      //     "Symbol": "960001345",
      //     "CurrTime": 193805,
      //     "CurrDate": 0,
      //     "LMT": 193805,
      //     "Exch": "CTG",
      //     "Product": "EQUITY",
      //     "ExchInstrNo": "CTG_960001345",
      //     "InstrNo": "960001345",
      //     "USymbol": "CTG_960001345"
      //   },
      //   "DataObject": {
      //     "TradeQty": 100,
      //     "TradePrice": 288.06,
      //     "LastTradeTime": "19:39:08",
      //     "NetChangeValue": -16.3,
      //     "NetChangePercentage": -5.35
      //   },
      //   "Segment": "TradeInfo"
      // }

      // let info = [{ "StockHeader": { "Symbol": "960001345", "CurrTime": 193805, "CurrDate": 0, "LMT": 193805, "Exch": "CTG", "Product": "EQUITY", "ExchInstrNo": "CTG_960001345", "InstrNo": "960001345", "USymbol": "CTG_960001345" }, "DataObject": { "TradeQty": 100, "TradePrice": 288.06, "LastTradeTime": "19:39:08", "NetChangeValue": 16.3, "NetChangePercentage": 5.35 }, "Segment": "TradeInfo" }, { "StockHeader": { "Symbol": "960001983", "CurrTime": 193805, "CurrDate": 0, "LMT": 193805, "Exch": "CTG", "Product": "EQUITY", "ExchInstrNo": "CTG_960001983", "InstrNo": "960001983", "USymbol": "CTG_960001983" }, "DataObject": { "TradeQty": 110, "TradePrice": 298.06, "LastTradeTime": "19:40:08", "NetChangeValue": 0, "NetChangePercentage": 0 }, "Segment": "TradeInfo" }, { "StockHeader": { "Symbol": "960001447", "CurrTime": 193805, "CurrDate": 0, "LMT": 193805, "Exch": "CTG", "Product": "EQUITY", "ExchInstrNo": "CTG_960001447", "InstrNo": "960001447", "USymbol": "CTG_960001447" }, "DataObject": { "TradeQty": 120, "TradePrice": 299.06, "LastTradeTime": "19:41:08", "NetChangeValue": 14.3, "NetChangePercentage": 7.35 }, "Segment": "TradeInfo" }, { "StockHeader": { "Symbol": "960000991", "CurrTime": 193805, "CurrDate": 0, "LMT": 193805, "Exch": "CTG", "Product": "EQUITY", "ExchInstrNo": "CTG_960000991", "InstrNo": "960000991", "USymbol": "CTG_960000991" }, "DataObject": { "TradeQty": 125, "TradePrice": 300.0, "LastTradeTime": "19:41:08", "NetChangeValue": -12.35, "NetChangePercentage": -8.30 }, "Segment": "TradeInfo" }];
      // let data = info[Math.floor(Math.random() * info.length)];

      // let exchSymbolKey = data.StockHeader.Exch + "#" + data.StockHeader.Product + "#" + data.StockHeader.Symbol;
      // let tickerObj = {};

      // if (this.services.dataStore.stockMasterMap.has(exchSymbolKey)) {
      //   let selectedStock = this.services.dataStore.stockMasterMap.get(exchSymbolKey);

      //   tickerObj["qty"] = data.DataObject.TradeQty;
      //   tickerObj["price"] = data.DataObject.TradePrice;
      //   tickerObj["ltt"] = data.DataObject.LastTradeTime;

      //   tickerObj["exch"] = this.services.dataStore.getDispExch(data.StockHeader.Exch);
      //   tickerObj["symbol"] = selectedStock.symbol;
      //   tickerObj["product"] = data.StockHeader.Product;
      //   tickerObj["netChangeValue"] = data.DataObject.NetChangeValue;
      //   tickerObj["netChangePercentage"] = data.DataObject.NetChangePercentage;

      //   // tickerObj["tickerColor"] = "default";
      //   if (data.DataObject.NetChangeValue >= selectedStock["netChangeValue"]) {
      //     tickerObj["tickerColor"] = "tickerIncr";
      //   } else if (data.DataObject.NetChangeValue < selectedStock["netChangeValue"]) {
      //     tickerObj["tickerColor"] = "tickerDecr";
      //   }

      //   selectedStock["netChangeValue"] = data.DataObject.NetChangeValue;
      //   selectedStock["netChangePercentage"] = data.DataObject.NetChangePercentage;
      // }

      // if (this.tickerList.length >= 6) {
      //   this.tickerList.splice(0, 1);
      // }
      // let stock = 'SECTOR';
      // let filter = ['12 BANK', '11 MUTUAL FUNDS', '16 ICT', '20 TELECOMMUNICATION'];
      // if (stock == "SECTOR") {
      //   if (filter.indexOf(
      //     this.services.dataStore.stockMasterMap.get(exchSymbolKey).sectorName) > -1) {
      //     this.tickerList.push(tickerObj);
      //   }
      // } else {
      //   this.tickerList.push(tickerObj);
      // }
      // Delete Ends

    } else {
      this.marketService.tickerUnSubs();
      this.tickerList = []; //Should be uncommented for release

      document.getElementById("MWTable").style.height = "calc(100vh - 190px)";
      document.getElementById("MWInfoPane").style.height = "calc(100vh - 190px)";
    }
  }

  getTickerInfo() {
    this.marketService.getTickerInfo().subscribe((data: any) => {
      // console.log('[%s] TickerInfo Received ', new Date(), data);

      if(data.StockHeader.Product == 2){
        data.StockHeader.Product = "COMDERV";
        this.services.UserPreference.selectedStock["stock"] = "COMDERV";
      }else if(data.StockHeader.Product == 13){
        data.StockHeader.Product = "FUTOPT";
        this.services.UserPreference.selectedStock["stock"] = "FUTOPT";
      }else if(data.StockHeader.Product == 5){
        data.StockHeader.Product = "EQUITY";
        this.services.UserPreference.selectedStock["stock"] = "EQUITY";
      }

      let exchSymbolKey = data.StockHeader.Exch + "#" + data.StockHeader.Product + "#" + data.StockHeader.Symbol;

      let tickerObj = {};
      if (this.services.dataStore.stockMasterMap.has(exchSymbolKey)) {
        let selectedStock = this.services.dataStore.stockMasterMap.get(exchSymbolKey);
        
        tickerObj["qty"] = data.DataObject.TradeQty;
        tickerObj["price"] = data.DataObject.TradePrice;
        tickerObj["ltt"] = data.DataObject.LastTradeTime;
        
        tickerObj["exch"] = this.services.dataStore.getDispExch(data.StockHeader.Exch);
        tickerObj["symbol"] = selectedStock.symbol;
        tickerObj["product"] = data.StockHeader.Product;
        tickerObj["netChangeValue"] = data.DataObject.NetChangeValue;
        tickerObj["netChangePercentage"] = data.DataObject.NetChangePercentage;
        // tickerObj["tickerColor"] = "default";
        //console.log("data.DataObject.NetChangeValue",data.DataObject.NetChangeValue);
        //console.log("selectedStock,netChangeVal",selectedStock["netChangeValue"]);

        /* // existing code is commented by shanmugapriya
        if (data.DataObject.NetChangeValue > selectedStock["netChangeValue"]) {
          tickerObj["tickerColor"] = "tickerIncr";
        } else if (data.DataObject.NetChangeValue < selectedStock["netChangeValue"]) {
          tickerObj["tickerColor"] = "tickerDecr";
        }*/
        /*if (data.DataObject.TradePrice > selectedStock["prevClose"]) { //prevclose added by shanmugapriya
          tickerObj["tickerColor"] = "tickerIncr";
        } else if (data.DataObject.TradePrice < selectedStock["prevClose"]) {
          tickerObj["tickerColor"] = "tickerDecr";
        }*/ //ticker condition added by shanmugapriya
        if (data.DataObject.NetChangeValue > 0 ) { 
          tickerObj["tickerColor"] = "tickerIncr";
        } else if (data.DataObject.NetChangeValue < 0) {
          tickerObj["tickerColor"] = "tickerDecr";
        }

        //selectedStock["netChangeValue"] = data.DataObject.NetChangeValue;//Value is coming in touchline, so dont want to update this vale here
        //selectedStock["netChangePercentage"] = data.DataObject.NetChangePercentage;////since we dont show change% in ticker, so commenting


        if (this.tickerList.length >= 6) {
          this.tickerList.splice(0, 1);
        }
        // this.tickerList.push(tickerObj);
        // **UserPreference
        if (this.services.UserPreference.selectedStock["stock"] == "SECTOR") {
          if (this.services.UserPreference.selectedStock["filter"].indexOf(
            this.services.dataStore.stockMasterMap.get(exchSymbolKey).sectorName) > -1) {
              this.tickerList.push(tickerObj);
          }
        } else if (this.services.UserPreference.selectedStock["stock"] == "MYPORTFOLIO") {
          if (this.MyPortfolioList.indexOf(exchSymbolKey) > -1) {
              this.tickerList.push(tickerObj);
          }
        } else {
          this.tickerList.push(tickerObj);
        }

      }else{
        console.log("Ticker Symbol doesnot match");
      }
    });
  }

  loadSectorAndProductList() {
    this.sectorList = [];
    this.services.dataStore.stockMaster.map(item => item.sectorName)
      .filter((value, index, self) => {
        if (self.indexOf(value) === index)
          this.sectorList.push(value)
      });

    this.selectedSector = this.sectorList[0];
    //this.productList = this.services.dataStore.getcmbProduct();
    this.productList = this.services.dataStore.getcmbProductderivative();
    
    this.productValue = this.productList;
    this.selectedProduct = this.productList[0].id;
  }

  onWatchListChange(value) {
    //console.log("onWatchListChange.......value",value);
    //console.log("this.selectedWatchList....",this.selectedWatchList);
    this.selectedWatchList = value;
    this.loadMarketWatch();
  }

  onSectorListChange(value) {
    this.selectedSector = value;
    this.loadMarketWatch();
  }

  onProductChange(value) {
    this.selectedProduct = value;
    this.reloadStock();
  }

  onSearchModeSelected(searchmode) {
    this.reloadStock();
  }

  async onStockSelected(event) {
    let stock;
    let data = event.toUpperCase();
    document.getElementById('marketErrMsg').innerHTML = "";
    if (data == undefined || data == null || data == "") {
    } else if (this.marketData != null) {
      if (this.selectedWatchList == "Sector") {
        var idx = this.marketData.findIndex(el => el[this.cmbStock.searchMode] == data && el.product == this.selectedProduct
          && el.sectorName == this.selectedSector);
      } else {
       // this.selectedProduct = this.services.dataStore.getProductForMarketWatch(this.selectedProduct);//commented by pooja 
       stock = this.services.dataStore.getProductForMarketWatch(this.selectedProduct);
       idx = this.marketData.findIndex(el => {
         // Log the values being compared
         data = data.trim();
         el[this.cmbStock.searchMode] = el[this.cmbStock.searchMode].trim().toUpperCase();
        //Check the condition
        //const condition = el[this.cmbStock.searchMode] == data.trim()  && el.product == this.selectedProduct;//commented by pooja
        const condition = el[this.cmbStock.searchMode] == data.trim()  && el.product == stock;
        return condition;

     });
        //idx = this.marketData.findIndex(el => el[this.cmbStock.searchMode] == data && el.product == this.selectedProduct);
      }

      if (idx ==-1){
         document.getElementById('marketErrMsg').innerHTML = "Stock is not available in list";
         }   
         else {
        await this.getSymbolDetail(idx);
        document.getElementById('row' + idx).scrollIntoView({ behavior: "smooth", block: "end" });
      }
    } else {
      document.getElementById('marketErrMsg').innerHTML = "Stock is not available in list";
    }
  }

  async reloadStock() {
    if (this.cmbStock != undefined) {
      //console.log("in reload stock...");
      let exch = this.services.dataStore.getData("exchangeID");
      let pdctSel = this.selectedProduct;
      this.cmbStock.gotxInput.val("");
            let pdct = this.selectedProduct;
            let board = "AL";
      if(pdct == "EQUITY" || pdct == "DEBT"){
        board = "AL";
   }else{
        board = "NR";
   }
   pdct = this.services.dataStore.getDerivativeTypeConverter(pdct);
      //this.cmbStock.source = this.services.dataStore.getcmbStockInput(this.cmbStock.searchMode, exch, this.selectedProduct,this.services.dataStore.getData('board'));
      this.cmbStock.source = this.services.dataStore.getcmbStockInput(this.cmbStock.searchMode, exch, pdct,board);
     // this.cstmProduct.cmbProduct.dropDownOptions.Options = this.services.dataStore.getcmbProductderivative();
      //this.cstmProduct.cmbProduct.setValue(pdctSel);
      this.selectedProduct = pdctSel;
    }
  }

  async loadMarketWatch() {
    //console.log("inside load marketwatch")
    this.hideSector = true;
    this.marketData = null;
    this.touchlineSelected = null;
    // let Data = ['NR','SP']
    // for(let i =0;i<Data.length;i++){
    // }
   //console.log("this.productValue.length------",this.productValue.length);
    for(let j=0 ; j < this.productValue.length ; j++){
     // if(( this.productValue[j].id == ("COMDERV")||  this.productValue[j].id == ("FUTCOM")|| this.productValue[j].id == ("OPTCOM")) && this.productValue.length == 2){
     //console.log("this.productValue[j].id",this.productValue[j].id);
     // if((( this.productValue[j].id == ("COMDERV")||  this.productValue[j].id == ("FUTCOM")|| this.productValue[j].id == ("OPTCOM")) && this.productValue.length == 2)||((this.productValue[j].id == ("FUTSTK")||  this.productValue[j].id == ("FUTIDX")||this.productValue[j].id == ("OPTSTK")||  this.productValue[j].id == ("OPTIDX")) && this.productValue.length == 4)){
       
     if(this.productValue[j].id == ("COMDERV")||  this.productValue[j].id == ("FUTCOM")|| this.productValue[j].id == ("OPTCOM")|| this.productValue[j].id == ("FUTSTK")||  this.productValue[j].id == ("FUTIDX")||this.productValue[j].id == ("OPTSTK")||  this.productValue[j].id == ("OPTIDX")){
        for(let i=0 ; i < this.watchlistModel.watchListOptions.length ; i++){
          if(this.watchlistModel.watchListOptions[i].text == "Sector"){ 
            //this.watchlistModel.watchListOptions = this.watchlistModel.watchListOptions.push(this.watchlistModel.watchListOptions[i]);
            this.watchlistModel.watchListOptions = this.watchlistModel.watchListOptions.filter(item => item !== this.watchlistModel.watchListOptions[i]);
          }else if(this.watchlistModel.watchListOptions[i].text == "CSCX"){
            this.watchlistModel.watchListOptions = this.watchlistModel.watchListOptions.filter(item => item !== this.watchlistModel.watchListOptions[i]);

          }else if(this.watchlistModel.watchListOptions[i].text == "CSE30"){
            this.watchlistModel.watchListOptions = this.watchlistModel.watchListOptions.filter(item => item !== this.watchlistModel.watchListOptions[i]);

          }else if(this.watchlistModel.watchListOptions[i].text == "Spot Watch"){
            this.watchlistModel.watchListOptions = this.watchlistModel.watchListOptions.filter(item => item !== this.watchlistModel.watchListOptions[i]);
          }else if(this.watchlistModel.watchListOptions[i].text == "My Portfolio"){
            this.watchlistModel.watchListOptions = this.watchlistModel.watchListOptions.filter(item => item !== this.watchlistModel.watchListOptions[i]);
          }
        }
  
      }
     else if(this.productValue[j].id ==("EQUITY")){
       //console.log("inside equity...>>")
       //console.log("in equity portfolio length..",this.portfolioLength);
       // console.log("this.watchlistModel.watchListOptions.length....>",this.watchlistModel.watchListOptions.length);   
        for(let i=0 ; i < this.watchlistModel.watchListOptions.length ; i++){
          if(this.watchlistModel.watchListOptions[i].text == "My Portfolio"&&this.portfolioLength<=0){
          //console.log("this.watchlistModel.watchListOptions[i].tex......>",this.watchlistModel.watchListOptions[i].text);
            //this.watchlistModel.watchListOptions = this.watchlistModel.watchListOptions.filter(item => item !== this.watchlistModel.watchListOptions[i]);
              this.watchlistModel.watchListOptions = this.watchlistModel.watchListOptions.filter(item => item.id !== "My Portfolio");
        //console.log("potfolio removed");
          }
      }
}
 
    }
 
    
  

    this.services.dataStore.setData('board','AL')
    if (this.selectedWatchList == "My Portfolio") {
      // this.services.dataStore.setData('board','');
    this.getMyPortfolio("loadMW");

    } else if (this.selectedWatchList == "Sector") {
      this.hideSector = false;
      let exch = this.services.dataStore.getData("exchangeID");
      let stockKey = exch + "#" + this.selectedProduct + "#NR#STOCKS";
      //this.marketData = this.services.dataStore.stockMasterMap.get(stockKey).filter(el => el.sectorName === this.selectedSector);
      this.marketData = this.services.dataStore.stockMasterMap.get(stockKey).filter(el => el.sectorName === this.selectedSector).slice(0,30);
    } else if (this.selectedWatchList == "Spot Watch") {
      this.services.dataStore.setData('board','SP')
      let exch = this.services.dataStore.getData("exchangeID");
      let stockKey = exch + "#" + this.selectedProduct + "#SP#STOCKS";
      this.marketData = this.services.dataStore.stockMasterMap.get(stockKey)

    } else if (this.services.dataStore.watchListMap.has(this.selectedWatchList)) { // Index/Custom WatchList
      this.marketData = this.services.dataStore.watchListMap.get(this.selectedWatchList).slice(0,30);
      //console.log("this.marketData.length for selectedwatchlist:",this.marketData);
    }
    let exch = this.services.dataStore.getData("exchangeID");
    this.cmbStock.source = this.services.dataStore.getcmbStockInput(this.cmbStock.searchMode, exch, this.selectedProduct,this.services.dataStore.getData('board'));
    await this.subscribeMarketData();
    this.cmbStock.gotxInput.val("");
  }
  async subscribeMarketData() {
    this.marketService.unSubscribeMarket(this.services.dataStore.subbedStocks);
    this.services.dataStore.subbedStocks = [];
    if (this.marketData != null && this.marketData.length >= 1) {
      this.marketData.forEach(el => el["boardName"] = this.filter.boardFilter(el.board));
      // default sort for last trade time
      // const sort = new Sort();
      // this.marketData.sort(sort.startSort("lastTradeTime", "desc", ""));
      // document.getElementById('lastTradeTime').setAttribute("data-order", "asc");
      // select first row
      await this.getSymbolDetail(0);
      this.marketWatchStockSubs();
    }
  }

  marketWatchStockSubs() {
    //console.log("subs marketdata");
    let reqStocks = [];
    this.marketData.forEach(element => {
      reqStocks.push({ "Symbol": element.exchSymbol, "Exch": element.exch, "Product": element.product });
    });
    this.services.dataStore.subbedStocks = reqStocks;
    //console.log("reqStocks...",reqStocks);
    this.marketService.marketWatchStockSubs(reqStocks);
  }

  async getSymbolDetail(idx: number) {
    this.touchlineSelected = idx;
    this.symbol = this.marketData[idx].symbol;
     if(this.symbol.startsWith("FUT")){
      this.showOptionChain = true;
    }else{
      this.showOptionChain = false;
    }

    this.gotxMenuComp.showOptionChain = this.showOptionChain;
    //console.log("OPChain this.showOptionChain",this.showOptionChain);
    //console.log("OPChain this.gotxMenuComp.showOptionChain",this.gotxMenuComp.showOptionChain);
    this.exchSymbol = this.marketData[idx].exchSymbol;
    this.exchange = this.marketData[idx].exch;
    this.product = this.marketData[idx].product;
    this.board = this.marketData[idx].board;

    this.symbolName = this.symbol;
    this.secName = this.marketData[idx].companyName;
    // inputMap.set('Body.exchange', this.exchange);
    // inputMap.set('Body.product', this.product);
    // inputMap.set('Body.reportType', "information");
    // inputMap.set('Body.symbol', this.symbol);
    // this.services.http.fetchApi('/stock/instrumentdetails', 'POST', inputMap).subscribe(
    //   async (httpResponse: HttpResponse<any>) => {
    //     var res = httpResponse.body;
    //     var respCode: any = res['respCode'];
    //     if (respCode != null && respCode == 0) {
    //       let resObj = res['response'];
    //       this.symbolName = resObj.excSymbol;
    //       this.secName = resObj.secName;
    //     } else {
    //       this.symbolName = "NA";
    //       this.secName = "NA";
    //     }
    //   },
    //   async (httpError) => {
    //     var err = httpError['error']
    //     if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
    //     }
    //     this.symbolName = "NA";
    //     this.secName = "NA";
    //   }
    // );

    // inputMap.clear();    
    // let inputMap = new Map();
    // inputMap.set('Body.exchange', this.exchange);
    // inputMap.set('Body.product', this.product);
    // inputMap.set('Body.symbol', this.symbol);

    let stockKey = this.exchange + "#" + this.product + "#" + this.board + "#" + this.symbol;
    this.selectedStock = this.services.dataStore.stockMasterMap.get(stockKey);
	this.marketService.getStockQuote(this.exchange, this.product, this.symbol, this.board);
    await this.getNews();
  }

  async getMyPortfolio(type: string) {
    let portfolio = [];
    let inputMap = new Map();
    inputMap.set('Body.clientid', this.services.dataStore.getData("userID"));
    inputMap.set('Body.instradingCode', "");
    inputMap.set('Body.marginGroupNo', 1);
    this.services.http.fetchApi('/statements/stock', 'POST', inputMap).subscribe(
      async (httpResponse: HttpResponse<any>) => {
        var res = httpResponse.body;
        var respCode: any = res['respCode'];
        if (respCode != null && respCode == 0) {
          let resObj = res['response'];
          let stmntList = resObj.stockStatementlist;
          if (stmntList.length > 0) {
            let exch = this.services.dataStore.getData("exchangeID");

            stmntList.forEach(el => {
              let stockKey = exch + "#" + el.product + "#NR#" + el.instradingCode;
              let spStockKey = exch + "#" + el.product + "#SP#" + el.instradingCode;
              if (this.services.dataStore.stockMasterMap.has(stockKey)) {
                portfolio.push(this.services.dataStore.stockMasterMap.get(stockKey));

              } else if (this.services.dataStore.stockMasterMap.has(spStockKey)) {
                portfolio.push(this.services.dataStore.stockMasterMap.get(spStockKey));
              }
            });

const alreadyExists = this.watchlistModel.watchListOptions.some(opt => opt.id === "My Portfolio");
    //console.log("portfolio** and watchlist exist",portfolio.length,alreadyExists);
    if (!alreadyExists) {
            if (portfolio.length > 0) {
          this.watchlistModel.watchListOptions.push({
          id: "My Portfolio",
          text: "My Portfolio",
          isCustom: false,
          isDefault: false
        });   
      }}
      this.portfolioLength=portfolio.length;
      //console.log("portfolio**length",this.portfolioLength);
            this.selectedWatchList = "My Portfolio"; //added by pooja
            this.marketData = portfolio;
            this.subscribeMarketData();
            this.buildMyPortfolioList(portfolio); // **UserPreference
            //console.log("portfolio.length...........>",portfolio.length);
            //console.log("this.defaultIndex",this.defaultIndex);
          } else if (type == "checkData" && portfolio.length <= 0 && this.selectedWatchList == "My Portfolio") {    
            //this.onWatchListChange(this.defaultIndex); //commented by pooja 
            this.onWatchListChange("CSE30");
          }else if(type == "checkData" && portfolio.length <= 0 && this.selectedWatchList != "My Portfolio"){
            this.onWatchListChange("CSE30");
          }
        }
      },
      async (httpError) => {
        var err = httpError['error']
        if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
        }
        if (type == "checkData" && portfolio.length <= 0 && this.selectedWatchList == "My Portfolio") {
          this.onWatchListChange(this.defaultIndex);
        }
      }
    );
  }

  async getNews() {
    // var res = {
    //   "respCode": "0",
    //   "errMsg": "",
    //   "response": [
    //     {
    //       "routingType": "1",
    //       "participantId": "KABIR",
    //       "subject": "Message including Symbol",
    //       "priority": "1",
    //       "exchange": "CSE",
    //       "publishDate": "20201215",
    //       "publishTime": "151417609000",
    //       "message": "Its a message including symbol.This is test news for testing the new GWS kit.Its an enhancement to the existing DWS which comes with a lot of new feature including custom dashboard , technical analysis.The back end technology is also updated as well.Announcement can be now filtered using symbol.",
    //       "exchangeSymbol": "ABBANK"
    //     },
    //     {
    //       "routingType": "1",
    //       "participantId": "KABIR",
    //       "subject": "Message including Symbol",
    //       "priority": "1",
    //       "exchange": "CSE",
    //       "publishDate": "20201215",
    //       "publishTime": "151417609000",
    //       "message": "Its a message including symbol.This is test news for testing the new GWS kit.Its an enhancement to the existing DWS which comes with a lot of new feature including custom dashboard , technical analysis.The back end technology is also updated as well.Announcement can be now filtered using symbol.",
    //       "exchangeSymbol": "ABBANK"
    //     }
    //   ],
    //   "sessionResponse": null,
    //   "target": null
    // };
    // this.newsList = res.response;
    let inputMap = new Map();
    inputMap.clear();
    inputMap.set('Body.startDate', this.services.dataStore.getData("sysDate"));
    inputMap.set('Body.endDate', this.services.dataStore.getData("sysDate"));
    inputMap.set('Body.endTime', "000000");
    inputMap.set('Body.exchangeSymbol', this.exchSymbol);
    inputMap.set('Body.routingType', 1);
    this.services.http.fetchApi('/market/news/query', 'POST', inputMap).subscribe(
      async (httpResponse: HttpResponse<any>) => {
        var res = httpResponse.body;
        var respCode: any = res['respCode'];
        if (respCode != null && respCode == 0) {
          this.newsList = res['response'];
        } else {
          // document.getElementById('errMsgDiv').innerHTML = res['errMsg'];
        }
      },
      async (httpError) => {
        var err = httpError['error']
        if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
        }
        // document.getElementById('errMsgDiv').innerHTML = this.transalte('ErrorCodes.SystemDown');
      }
    );
  }

  openEditColumn() {
    this.editColumn.emit("Market Watch Edit Columns");
  }

  async refreshSymbol() {
    if (this.touchlineSelected != null)
      await this.getSymbolDetail(this.touchlineSelected);
  }

  contextmenuMenu(): boolean {
    return this.gotxMenuComp.contextmenuMenu();
  }
  async mousedown(event: any, idx) {
    this.contextMenuRowSelected = idx;
    await this.getSymbolDetail(idx);
    this.gotxMenuComp.mousedown(event);
    // let rightClick = this.isRightClick(event) || jqx.mobile.isTouchDevice();
    // if (rightClick) {
    //   this.gotxMenuComp.gotxMenu.open(parseInt(event.clientX), parseInt(event.clientY));
    //   return false;
    // }
  }

  selectedCntxtMenu(event) {
    this.gotxMenuComp.gotxMenu.close();
    if (event == "Buy" || event == "Sell") {
      this.openOrderEntry(event, this.contextMenuRowSelected);
    } else if (event == "Market Depth") {
      this.openMarketDepth(this.contextMenuRowSelected);
    } else if (event == "Chart") {
      this.openChart(this.contextMenuRowSelected);
    } else if (event == "Market News") {
      this.openModal(event);
    } else if (event == "Remove Stock") {
      this.removeStock(this.contextMenuRowSelected);
    }else if(event == "Option Chain"){
     //this.openModal(event);
     this.openOptionChain(this.contextMenuRowSelected);
    }
  }

  openOrderEntry(modal, idx) {
    let params = {
      symbol: this.marketData[idx].symbol,
      exchange: this.marketData[idx].exch,
      product: this.marketData[idx].product, //changed by pooja as commodity stock opened from market watch , product not populated properly
      exchSymbol: this.marketData[idx].exchSymbol,
      board: this.marketData[idx].board,
      underlying: this.marketData[idx].underlyingType,
      // order: order,
      price: 0,
      qty: 0,
      orderEntryType: ''
    }
    if(params.underlying == null){
      params.underlying = "EQUITY";
    }
    params.product = this.services.dataStore.convertProductMap(params.underlying);
    if (modal == "buyPrice" || modal == "Sell") {
      modal = "Sell";
      params.price = this.marketData[idx].buyPrice;
      params.qty = this.marketData[idx].buyQty;
      params.orderEntryType = "SELL";

    } else if (modal == "sellPrice" || modal == "Buy") {
      modal = "Buy";
      params.price = this.marketData[idx].sellPrice;
      params.qty = this.marketData[idx].sellQty;
      params.orderEntryType = "BUY";
    }

    this.openModal(modal, params);
  }

  openMarketDepth(idx) {
    let params = {
      symbol: this.marketData[idx].symbol,
      exchange: this.marketData[idx].exch,
      product: this.marketData[idx].product,
      exchSymbol: this.marketData[idx].exchSymbol
    }
    this.openModal("Market Depth", params);
  }

  openChart(idx) {
    let params = {
      symbol: this.marketData[idx].symbol,
      exchange: this.marketData[idx].exch,
      product: this.marketData[idx].product,
      exchSymbol: this.marketData[idx].exchSymbol
    }
    this.openModal("Intraday Chart", params);
  }
  openOptionChain(idx) {
    let params = {
      symbol: this.marketData[idx].symbol,
      exchange: this.marketData[idx].displayExch,
      product: this.marketData[idx].product,
      underlyingType: this.marketData[idx].underlyingType,
      exchSymbol: this.marketData[idx].exchSymbol,
      underlying: this.marketData[idx].underlying
    }
   if(params.symbol.startsWith("FUT")){
    this.openModal("Option Chain", params);
   }/*else{
    alert("Option Chain available only for future stocks");
   }*/
   // this.openModal("Option Chain", params);
  }

  removeStock(idx) {
    let symbol = this.marketData[idx].symbol;
    let exchange = this.marketData[idx].exch;
    let product = this.marketData[idx].product;

    let watchlistObj = this.watchlistModel.getWatchlist().filter(el => el.id == this.selectedWatchList)[0];
    if (watchlistObj.isCustom) {
      let stockInWatchlist = this.services.dataStore.watchListMap.get(this.selectedWatchList);
      stockInWatchlist.forEach((item, index) => {
        if (item.symbol === symbol && item.exch === exchange && item.product === product) {
          stockInWatchlist.splice(index, 1);
        }
      });
    } else {
      alert("You can remove stock from custom watch list only");
    }
  }

  openModal(modal, params = null) {
    const modalRef = this.services.openModal(gotxModalComponent, 'lg', params, modal);
    modalRef.result.then((res) => {
      if (modal == "Watchlist" && res == this.selectedWatchList) {
        this.marketData = this.services.dataStore.watchListMap.get(this.selectedWatchList);
      }
    }, () => {
    });
  }
  

  async buildMyPortfolioList(portfolio: any[]) {
    this.MyPortfolioList = [];
    portfolio.forEach(element => {
      let exchSymbolKey = element["exch"] + "#" + element["product"] + "#" + element["exchSymbol"];
      this.MyPortfolioList.push(exchSymbolKey);
    });
  }

}